if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  window.debounce = debounce
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
  var event = new CustomEvent(eventName, data ? { detail: data } : null)
  document.dispatchEvent(event)
}

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super()
      this.input = this.querySelector('.qty')
      this.step = this.input.getAttribute('step')
      this.changeEvent = new Event('change', {
        bubbles: true,
      })
      // Create buttons
      this.subtract = this.querySelector('.minus')
      this.add = this.querySelector('.plus')
      // Add functionality to buttons
      this.addEventListener('click', (evt) => {
        if (evt.currentTarget.contains(evt.target.closest('.minus'))) {
          this.change_quantity(-1 * this.step)
        }
        if (evt.currentTarget.contains(evt.target.closest('.plus'))) {
          this.change_quantity(1 * this.step)
        }
      })

      this.validateQtyRules()
    }
    connectedCallback() {
      this.classList.add('buttons_added')
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value)

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1

      // Check for min & max
      if (this.input.getAttribute('min') > quantity + change) {
        return
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < quantity + change) {
          return
        }
      }

      // Change quantity
      quantity += change

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1)

      // Output number
      this.input.value = quantity

      this.input.dispatchEvent(this.changeEvent)

      this.validateQtyRules()
    }
    validateQtyRules() {
      const value = parseInt(this.input.value)
      if (this.input.min) {
        const min = parseInt(this.input.min)
        this.subtract.classList.toggle('disabled', value <= min)
      }
      if (this.input.max) {
        const max = parseInt(this.input.max)
        this.add.classList.toggle('disabled', value >= max)
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput)
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu')
    this.arrow = self
    self.addEventListener('click', e => this.toggle_submenu(e))
  }

  toggle_submenu(e) {
    e.preventDefault()
    let submenu = this.submenu

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active')
    } else {
      submenu.classList.remove('active')
      this.arrow.blur()
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow')
arrows.forEach(arrow => {
  new ArrowSubMenu(arrow)
})

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super()
      this.swatches = this.querySelector('.product-card-swatches')
      this.image = this.querySelector('.product-featured-image-link .product-primary-image')
      this.additional_images = this.querySelectorAll('.product-secondary-image')
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li')
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple')
      this.loadingClass = this.dataset.loadingClass || 'loading'
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image)
      }
      if (this.additional_images.length) {
        this.enableAdditionalImages()
      }
      if (this.quick_add) {
        this.enableQuickAdd()
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length
      let images = this.additional_images
      let nav = this.additional_images_nav
      let image_container = this.querySelector('.product-featured-image')
      if (!image_container) return
      const mousemove = function (e) {
        let l = e.offsetX
        let w = this.getBoundingClientRect().width
        let prc = l / w
        let sel = Math.floor(prc * image_length)
        let selimg = images[sel]
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover')
            if (nav.length) {
              nav[index].classList.remove('active')
            }
          }
        })
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover')
            if (nav.length) {
              nav[sel].classList.add('active')
            }
          }
        }
      }
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover')
          if (nav.length) {
            nav[index].classList.remove('active')
          }
        })
      }
      image_container.addEventListener('touchstart', mousemove, {
        passive: true,
      })
      image_container.addEventListener('touchmove', mousemove, {
        passive: true,
      })
      image_container.addEventListener('touchend', mouseleave, {
        passive: true,
      })
      image_container.addEventListener('mouseenter', mousemove, {
        passive: true,
      })
      image_container.addEventListener('mousemove', mousemove, {
        passive: true,
      })
      image_container.addEventListener('mouseleave', mouseleave, {
        passive: true,
      })
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '',
        active = swatches.querySelector('.product-card-swatch.active')

      swatch_list.forEach((swatch, index) => {
        swatch.addEventListener('mouseover', function () {
          ;[].forEach.call(swatch_list, function (el) {
            el.classList.remove('active')
          })
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset)
            } else {
              image.setAttribute('srcset', org_srcset)
            }
          }

          swatch.classList.add('active')
        })
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href
          evt.preventDefault()
        })
      })
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this))
    }

    quickAdd(evt) {
      evt.preventDefault()
      if (this.quick_add.disabled) {
        return
      }
      this.quick_add.disabled = true
      this.quick_add.classList.add(this.loadingClass)
      this.quick_add.setAttribute('aria-disabled', true)

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
      }

      let formData = new FormData(this.form)

      formData.append('id', this.quick_add.dataset.productId)
      formData.append('quantity', 1)
      formData.append(
        'sections',
        this.getSectionsToRender().map(section => section.section)
      )
      formData.append('sections_url', window.location.pathname)

      config.body = formData

      fetch(`${theme.routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            return
          }
          this.renderContents(response)

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response,
          })
        })
        .catch(e => {
          console.error(e)
        })
        .finally(() => {
          this.quick_add.classList.remove(this.loadingClass)
          this.quick_add.removeAttribute('aria-disabled')
          this.quick_add.disabled = false
        })

      return false
    }
    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form',
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer',
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count',
        },
      ]
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach(section => {
        if (!document.getElementById(section.id)) {
          return
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer()
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState)
        }
      })

      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc')
        document.getElementById('Cart-Drawer').classList.add('active')

        dispatchCustomEvent('cart-drawer:open')
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
    }
  }
  customElements.define('product-card', ProductCard)
}
/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super()

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true')
      this.button = this.querySelector('button')
      this.id = this.dataset.id
      this.url = this.dataset.url
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners()
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this))
    }
    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form',
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer',
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count',
        },
      ]
    }

    addToCart() {
      this.button.classList.add('loading')
      this.button.setAttribute('aria-disabled', true)

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
      }

      let formData = new FormData(this.form)

      formData.append('id', this.id)
      formData.append('quantity', 1)
      formData.append(
        'sections',
        this.getSectionsToRender().map(section => section.section)
      )
      formData.append('sections_url', window.location.pathname)

      config.body = formData

      fetch(`${theme.routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            return
          }

          this.renderContents(response)

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response,
          })
        })
        .catch(e => {
          console.error(e)
        })
        .finally(() => {
          this.button.classList.remove('loading')
          this.button.removeAttribute('aria-disabled')
        })
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach(section => {
        if (!document.getElementById(section.id)) {
          return
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer()
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState)
        }
      })
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc')
        document.getElementById('Cart-Drawer').classList.add('active')
        dispatchCustomEvent('cart-drawer:open')
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
    }
  }
  customElements.define('product-card-small', ProductCardSmall)
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {
  constructor() {
    super()
    let cc = document.querySelector('.click-capture')

    // Add functionality to buttons
    this.addEventListener('click', e => this.close_panel(e))
    document.addEventListener('keyup', e => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach(panel => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product')
              document.querySelector('#Product-Drawer-Content').innerHTML = ''
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus()
              }
              document.body.classList.remove('open-cc')
            }
            panel.classList.remove('active')
          })
        }
      }
    })
    cc.addEventListener('click', e => {
      let panel = document.querySelector('.side-panel.active')
      if (panel) {
        panel.classList.remove('active')
        document.body.classList.remove('open-cc')
      }
    })
  }

  close_panel(e) {
    e.preventDefault()
    let panel = e.target.closest('.side-panel')
    panel.classList.remove('active')
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product')
      document.querySelector('#Product-Drawer-Content').innerHTML = ''
    } else {
      document.body.classList.remove('open-cc')
    }
  }
}
customElements.define('side-panel-close', PanelClose)

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {
  constructor() {
    this.container = document.getElementById('Cart-Drawer')

    if (!this.container) {
      return
    }
    const button = document.getElementById('cart-drawer-toggle')
      // quantities = this.container.querySelectorAll('.quantity input'),
      // checkout_button = this.container.querySelector('.button.checkout')
    button?.addEventListener('click', e => {
      e.preventDefault()
      document.body.classList.add('open-cc')
      this.container.classList.add('active')
      this.container.focus()
      dispatchCustomEvent('cart-drawer:open')
    })

    this.debouncedOnChange = debounce(event => {
      this.onChange(event)
    }, 300)

    this.container.addEventListener('change', this.debouncedOnChange)

    this.notesToggle()
    this.removeProductEvent()
    // Terms checkbox
    this.termsCheckbox()
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value)
    }
  }
  removeProductEvent() {
    this.container.addEventListener('click', evt => {
      const target = evt.target.closest('.remove')
      if (target && evt.currentTarget.contains(target)) {
        evt.preventDefault()
        this.updateQuantity(target.dataset.index, '0')
      }
    })
  }
  getSectionsToRender() {
    return [
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer',
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count',
      },
    ]
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout')

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms)
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity()
          terms_checkbox.focus()
          e.preventDefault()
        }
      })
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle')

    if (!notes_toggle) {
      return
    }

    notes_toggle.addEventListener('click', event => {
      notes_toggle.nextElementSibling.classList.add('active')
    })
    notes_toggle.nextElementSibling.addEventListener('click', (evt) => {
      if (evt.target.closest('.button, .order-note-toggle__content-overlay')) {
        notes_toggle.nextElementSibling.classList.remove('active')
        this.saveNotes()
      }
    })
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`,
      },
      body: JSON.stringify({
        note: document.getElementById('mini-cart__notes').value,
      }),
    })
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading')
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname,
    })

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity,
    })
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`,
      },
      body,
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state)

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            )
          }
        })
        this.removeProductEvent()
        this.notesToggle()
        this.termsCheckbox()
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState,
        })
        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading')
        }
      })
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this))
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide()
      })
    } else {
      this.addEventListener('click', event => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
      })
    }
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
    this.querySelectorAll('.js-youtube').forEach(video => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
    })
    this.querySelectorAll('.js-vimeo').forEach(video => {
      video.contentWindow.postMessage('{"method":"pause"}', '*')
    })
    this.querySelectorAll('video').forEach(video => video.pause())
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()
    const button = this.querySelector('button');
    if (!button) return
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(this.resizeSelect)
    })

    document.body.addEventListener('change', e => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        this.resizeSelect(e.target)
      }
    })
    window.addEventListener('resize.resize-select', () => {
      document.querySelectorAll('.resize-select').forEach(this.resizeSelect)
    })
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option')
    tempOption.textContent = sel.selectedOptions[0].textContent

    let tempSelect = document.createElement('select')
    tempSelect.style.visibility = 'hidden'
    tempSelect.style.position = 'fixed'
    tempSelect.appendChild(tempOption)

    sel.after(tempSelect)
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`
    }
    tempSelect.remove()
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth()
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    // resize on initial load
    document.querySelector('#footer')?.addEventListener('click', evt => {
      const button = evt.target.closest('.thb-widget-title.collapsible')
      if (button && evt.currentTarget.contains(button)) {
        button.classList.toggle('active')
      }
    })
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super()
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      }
      this.autoClose = this.dataset.autoClose
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this))
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this))
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

      this.detailsements.panel && this.detailsements.panel
        .querySelectorAll('button')
        .forEach(item => item.addEventListener('click', this.onItemClick.bind(this)))
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false')
      const section = this.closest('.shopify-section');
      if (section) section.style.zIndex = 52;
      this.classList.remove('custom-select--active')
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return

      this.hidePanel()
      this.detailsements.button.focus()
    }

    onItemClick(event) {
      event.preventDefault()
      this.detailsements.input.value = event.currentTarget.dataset.value
      this.detailsements.input.dispatchEvent(new Event('change'))
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'))
        this.detailsements.form.submit()
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active')
      }
    }

    toggleSelector(event) {
      event.preventDefault()
      this.classList.toggle('custom-select--active')
      if (this.classList.contains('custom-select--active')) {
        const section = this.closest('.shopify-section');
        if (section) section.style.zIndex = 54;
        this.detailsements.button.focus()
        this.detailsements.button.setAttribute(
          'aria-expanded',
          (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString()
        )
      } else {
        this.hidePanel()
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button')
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel()
      }
    }
  }
  customElements.define('custom-select', CustomSelect)
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.debouncedOnSubmit = debounce(event => {
        this.onSubmitHandler(event)
      }, 200)
      this.form = this.querySelector('form')
      this.form.addEventListener('change', evt => {
        if (evt.target.closest('input[name="locale_code"], input[name="country_code"]')) {
          this.debouncedOnSubmit(evt)
        }
      })
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit()
    }
  }
  customElements.define('localization-form', LocalizationForm)
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    connectedCallback() {
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel')
      this.setupButtonObservers()
    }
    setupButtonObservers() {
      this.buttons = this.querySelectorAll('button')
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', e => {
          this.toggleActiveClass(i)
        })
      })
    }
    toggleActiveClass(i) {
      this.buttons.forEach(button => {
        button.classList.remove('tab-active')
      })
      this.buttons[i].classList.add('tab-active')

      this.panels.forEach(panel => {
        panel.classList.remove('tab-active')
      })
      this.panels[i].classList.add('tab-active')
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs)
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super()

      this.details = this.querySelector('details')
      this.summary = this.querySelector('summary')
      this.content = this.querySelector('.collapsible__content')

      this.animation = null
      this.isClosing = false
      this.isExpanding = false
    }
    connectedCallback() {
      this.setListeners()
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', e => this.onClick(e))
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height

      this.tl = false
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'none',
        onStart: function () {
          _this.details.open = true
          _this.details.style.overflow = 'hidden'
        },
        onReverseComplete: function () {
          _this.details.open = false
          _this.details.style.overflow = ''
        },
      })

      this.tl.fromTo(
        _this.details,
        {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24)
            return h
          },
          clearProps: 'height',
        },
        {
          duration: 0.4,
          height: final_height,
          clearProps: 'height',
        }
      )

      if (this.details.open) {
        this.tl.progress(1)
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse()
    }
    animateClose() {
      this.tl.timeScale(3).reverse()
    }
    animateOpen() {
      this.tl.timeScale(1).play()
    }
    onClick(e) {
      e.preventDefault()
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden'
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open()
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink()
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel()
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 250,
          easing: 'ease',
        }
      )

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false)
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => (this.isClosing = false)
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`
      // Force the [open] attribute on the details element
      this.details.open = true
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand())
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`

      // If there is already an animation running
      if (this.animation) {
        this.animation.cancel()
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      )
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true)
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => (this.isExpanding = false)
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open
      // Clear the stored animation
      this.animation = null
      // Reset isClosing & isExpanding
      this.isClosing = false
      this.isExpanding = false
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = ''
    }
  }
  customElements.define('collapsible-row', CollapsibleRow)
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  fetchProducts(isFallback = false) {
    let url = this.dataset.url
    if (isFallback) {
      const urlObj = new URL(/^\//.test(url) ? window.location.origin + url : url)
      urlObj.searchParams.set('intent', 'related')
      url = urlObj.toString()
    }
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('product-recommendations')

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
          this.classList.add('product-recommendations--loaded')
        } else if (!isFallback) {
          this.fetchProducts(true)
        }
      })
      .catch(e => {
        console.error(e)
      })
  }
  connectedCallback() {
    this.fetchProducts()
  }
}

customElements.define('product-recommendations', ProductRecommendations)

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product')
      this.drawer = document.getElementById('Product-Drawer')
      this.body = document.body

      this.addEventListener('click', this.setupEventListener.bind(this))
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this))
    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product')
      this.drawer.classList.remove('active')
      this.drawer.querySelector('#Product-Drawer-Content').innerHTML = ''
    }
    setupEventListener(e) {
      e.preventDefault()
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/')
      if (!href || !productHandle) {
        return
      }
      if (this.classList.contains('loading')) {
        return
      }
      this.classList.add('loading')
      fetch(href, { method: 'GET' })
        .then(response => {
          this.classList.remove('loading')
          return response.text()
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML

          this.renderQuickview(sectionInnerHTML, href, productHandle)
        })
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script')

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0]
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script')
            script.src = js_file.src
            head.appendChild(script)
          })
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init()
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR()
          }
        }, 300)

        this.body.classList.add('open-cc--product')
        this.drawer.classList.add('active')

        this.drawer.querySelector('.side-panel-close').focus()

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider'),
            flkty = Flickity.data(slider)

          flkty.reposition()
        }, 100)
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle,
        })
      }
    }
  }
  customElements.define('quick-view', QuickView)
}

if (!customElements.get('flash-sales-countdown')) {
  customElements.define('flash-sales-countdown', class extends HTMLElement {
    tId = 0;
    endsAt = null;
    connectedCallback() {
      const endsAt = this.getAttribute('ends-at');
      const hideUntilNDays = this.getAttribute('hide-until-n-days');
      const date = new Date(endsAt);
      if (hideUntilNDays) {
        const now = new Date();
        const nDaysInMs = parseInt(hideUntilNDays, 10) * 24 * 60 * 60 * 1000;
        const hideUntil = new Date(date.getTime() - nDaysInMs);
        if (now < hideUntil) return
      }
      if (date) {
        this.endsAt = date
        this.start()
      }
    }

    start() {
      clearTimeout(this.tId)
      const endsAt = this.endsAt
      const timeout = 1000
      function padZero(num) {
        return ('00'+num.toString()).slice(-2)
      }
      const template = this.querySelector('template')
      const root = template.content.cloneNode(true)
      const daysEl = root.querySelector('.days .countdown-timer--column--number')
      const hoursEl = root.querySelector('.hours .countdown-timer--column--number')
      const minutesEl = root.querySelector('.minutes .countdown-timer--column--number')
      const secondsEl = root.querySelector('.seconds .countdown-timer--column--number')
      const update = () => {
        const endsAtTime = endsAt.getTime()
        const now = Date.now()
        const distance = endsAtTime - now
        if (distance < 0) {
          this.parentElement.removeChild(this)
          return
        } else {
          const days = Math.min(99, Math.floor(distance / (1000 * 60 * 60 * 24)));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          daysEl.innerText = padZero(days)
          hoursEl.innerText = padZero(hours)
          minutesEl.innerText = padZero(minutes)
          secondsEl.innerText = padZero(seconds)
          if (days < 1) {
            root.querySelector('.days .countdown-timer--column--number')?.setAttribute('hidden', '')
            root.querySelector('.days .countdown-timer--column--text')?.setAttribute('hidden', '')
          }
        }
        this.tId = setTimeout(update, timeout)
      }
      if (endsAt) {
        update()
        this.appendChild(root)
      }
    }
  })
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {
  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path')
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined'

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners()
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: '0%',
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%',
        },
      })
    })
  }
}
document.addEventListener('DOMContentLoaded', () => {
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer()
  }
  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers()
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle()
  }
  try {
    if (Shopify.theme.role !== 'main') { document.body.classList.add('is-not-main') }
  } catch { /** NOOP */}
});

/** 
* Bundle page navigation
*/

const navItems = document.querySelectorAll('.bundle_nav-items');

navItems.forEach(function(nav) {
  const links = nav.querySelectorAll('a');

  links.forEach(function(link) {
    link.addEventListener('click', function() {
      links.forEach(function(otherLink) {
        otherLink.classList.remove('active');
      });

      this.classList.add('active');

      
      document.querySelector(".bundle_nav-items--mobile").scrollTo({
        left: (this.offsetLeft + this.clientWidth / 2) - document.body.clientWidth / 2,
        behavior: "smooth"
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var selectedFlickity = {}
  window.addEventListener('scroll', debounce(() => {
    const s = document.querySelector(".bundle_nav-items--mobile .bundle_nav-items__cell.active")
    if(selectedFlickity != s){
      selectedFlickity = s
      document.querySelector(".bundle_nav-items--mobile")?.scrollTo({
        left: (selectedFlickity.offsetLeft + selectedFlickity.clientWidth / 2) - document.body.clientWidth / 2,
        behavior: "smooth"
      });
    }
  }, 300), {
     passive: true
  });
});

  document.querySelectorAll('.feature-chart--mobile-button').forEach(function (el) {
    let hides = el.closest('.feature-chart').querySelectorAll('.more-item')
    let button = el.querySelector('.button-title')
    el.addEventListener('click', e => {
      if (button.innerText == el.getAttribute('data-view-more')) {
        hides.forEach(item => {
          item.classList.remove('mobile-hide')
        })
        button.innerText = el.getAttribute('data-view-less')
      } else {
        hides.forEach(item => {
          item.classList.add('mobile-hide')
        })
        button.innerText = el.getAttribute('data-view-more')
      }
    })
  })
  document.querySelectorAll('.revy-bundle-wrapper-inner').forEach(function (e) {
    let original = e.querySelector('.original-price span').innerText
    let current = e.querySelector('.current-price span').innerText
    let money = original.charAt(0)
    console.log(money, original, current)
    e.querySelector('.original-price span').innerText =
      original.charAt(0) + (parseInt(original.replace(money, '')) + parseInt(current.replace(money, '')))
  })

// Sticky Nav
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.sticky-navigation')) {
    let sticky_bar_height = 0;
    let offset = 300;
    let linkClicked = false;

    const nav = document.querySelector('.bundle_nav-items');

    const scrollOffset = nav.getAttribute('data-scroll-offset');

    const links_desktop = document.querySelectorAll('.bundle_nav-items--desktop a');
    const links_mobile = document.querySelectorAll('.bundle_nav-items--mobile a');

    updateOnClickStickyNavState(links_desktop);
    updateOnClickStickyNavState(links_mobile);

    window.onscroll = function () {
      const scrollPos_start = window.scrollY + sticky_bar_height + offset;
      const scrollPos_end = window.scrollY + sticky_bar_height;

      if (!linkClicked) {
        updateStickyNavState(links_desktop, scrollPos_start);
        updateStickyNavState(links_mobile, scrollPos_start);
      }
    };

    function updateOnClickStickyNavState(links) {
      links.forEach(function (e) {
        var section_id = (e.getAttribute('href') == '#' ? '#no-valid-selector' : e.getAttribute('href')) || '';
        var section_id_trans = section_id.toLowerCase().replace(/\s+/g, '-').replace(/[^-a-zA-Z0-9]/g, '')
        if (!section_id) return

        var refElement
        try {
          refElement = document.querySelector(section_id)
        } catch {
          refElement = document.querySelector(`[id="${section_id.replace('#', '')}"]`) || document.querySelector(section_id_trans)
        }

        if (refElement) {
          e.onclick = function (evt) {
            evt.preventDefault();
            
            linkClicked = true;

            var section_top = refElement.getBoundingClientRect().top + window.scrollY - sticky_bar_height - scrollOffset;

            setTimeout(function () {
              window.scroll({
                top: section_top,
                behavior: 'smooth',
              });
            }, 100);

            setTimeout(function () {
              linkClicked = false;
            }, 1000);
          };
        }
      });
    }

    function updateStickyNavState(links, scrollPos_start) {
      links.forEach(function (e) {
        var section_id = (e.getAttribute('href') == '#' ? '#no-valid-selector' : e.getAttribute('href')) || '';
        var section_id_trans = section_id.toLowerCase().replace(/\s+/g, '-').replace(/[^-a-zA-Z0-9]/g, '');
        if (!section_id) return

        var refElement
        try {
          refElement = document.querySelector(section_id)
        } catch {
          refElement = document.querySelector(`[id="${section_id.replace('#', '')}"]`) || document.querySelector(section_id_trans)
        }
        if (refElement) {
          const section_top = refElement.getBoundingClientRect().top + window.scrollY;

          if (scrollPos_start >= section_top) {
            links.forEach(function (link) {
              if (link !== e) {
                link.classList.remove('active');
              }
            });

            e.classList.add('active');
          }
        }
      });
    }
  }
});
